import {
    type UpdateDriveFolderResponseType,
    type UpdateDriveFolderRequestType
} from "./type";
import {
    request
} from "../request";

const UpdateDriveFolder = async (params: UpdateDriveFolderRequestType): Promise<UpdateDriveFolderResponseType> => {
    return await request<UpdateDriveFolderResponseType>("/drive/updateDriveFolder", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default UpdateDriveFolder;
